import React, { useEffect, useState } from "react";
import styles from "./salon.module.css";
import { useDispatch, useSelector } from "react-redux";
import SearchAndFilter from "../Components/SearchAndFilter/SearchAndFilter";
import { SalonConfig } from "../Salon/SalonConfig";
import { SalonList } from "./Components/SalonList/SalonList";
import { SalonDetails } from "./Components/SalonDetails/SalonDetails";
import { loadData } from "../Utils/localStorage";
import { Logo } from "../Components/Logo";
import { TopHeader } from "../Components/TopHeaderNav/TopHeader";
import { getAllSalonSpaServices } from "../Components/Redux/salonSpaServicesSlice";

const Salon = () => {
  const { searchValue, status, category, availableDays } = useSelector(
    (state) => state.searchSlice
  );
  const { Loader, salonSpaServicesList } = useSelector(
    (state) => state.salonSpaServicesSlice
  );
  const dispatch = useDispatch();
  const [categoryArr, setCategoriesArr] = useState([]);
  const club_id=loadData("Club_id");
  let dropdownOption = [
    {
      id: 0,
      name: "Available",
    },
    {
      id: 1,
      name: "Unavailable",
    },
  ];

  const getAllSalonSpaServicesFunc = () => {
    let data = categoryArr?.find((cat) => {
      return cat?.name == category;
    });
    let payload = {
      club_id: loadData("Club_id"),
      user_id: loadData("Token"),
      request_by: "Admin",
      service: "SALON",
    };
    if (status !== "") {
      if (status === "Available") {
        payload["status"] = true;
      } else {
        payload["status"] = false;
      }
    }
    if (category !== "") {
      payload["categories"] = [data?.id];
    }
    if (availableDays.length > 0) {
      payload["availability"] = availableDays;
    }
    if (searchValue !== "") {
      payload["name"] = searchValue;
    }
    dispatch(getAllSalonSpaServices(payload));
  };

  useEffect(() => {
    let payload = {
      club_id: loadData("Club_id"),
      user_id: loadData("Token"),
      request_by: "Admin",
      service: "SALON",
      status: 1,
    };
    fetch(`${process.env.REACT_APP_API_URL}/api/services/get-category`, {
      method: "POST",
      body: JSON.stringify(payload),
      headers: {
        "content-type": "application/json",
        Authorization: loadData("Auth"),
      },
    })
      .then((d) => d.json())
      .then((res) => {
        setCategoriesArr(res?.data?.categories);
      })
      .catch((err) => {});
  }, [club_id]);

  useEffect(() => {
    const timer = setTimeout(() => {
      getAllSalonSpaServicesFunc();
    }, 500);
    return () => clearTimeout(timer);
  }, [status, category, searchValue,availableDays,club_id]);

  return (
    <div className={styles.mainDivEvents}>
      <TopHeader
        title={"Salon"}
        showBtn={true}
        btnTitle31={"Create Service"}
        btnTitle52={"Professionals"}
        btnTitle63={"Create Booking"}
        btnTitle55={"Bookings"}
        to31={SalonConfig.CreateSalon}
        to52={SalonConfig.Professionals}
        to63={SalonConfig.CreateBooking}
        to55={SalonConfig.SchedularView}
        headerType={"salon"}
      />
      <SearchAndFilter
        handleSearch={getAllSalonSpaServicesFunc}
        dropdownOption={dropdownOption}
        showStatus={true}
        categoryArr={categoryArr}
        showCategory={true}
        showAvailability={true}
        showAccessibleTo={false}
        categoryTitle={"Category"}
        filterType={"salonFilter"}
      />
      {Loader ? (
        <Logo />
      ) : (
        <>
          {salonSpaServicesList?.length !== 0 ? (
            <div className={styles.mainMidDivEvents}>
              <div className={styles.divEventList}>
                <SalonList />
              </div>
              <SalonDetails />
            </div>
          ) : (
            <div className={styles.noDataMainDiv}>
              <div className={styles.noDataDiv}>
                <span className={styles.noDataImgDiv}>
                  <img
                    src={`${process.env.PUBLIC_URL}/${process.env.REACT_APP_IMAGES}/NoData.png`}
                  />
                </span>
                <h2>Not Found</h2>
                <p>Search did not match current service listed</p>
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default Salon;
